export default __webpack_public_path__ + "static/media/gallery_06.0baf0287.jpg";